// // Import required libraries
import List from 'list.js'

import css from './styles.css';
import { getScoringDrivesEspn, getProxiedEspnRequestPromise, getMatchupPredictionEspn, getLiveSnapshotEspn, getCachedMatchupPredictionEspn } from './w2w-espn';
import { computeLiveWatchability, kLiveEarlyGameMinutes } from './liveWatchability';

const kMinElo = 1100;
const kMaxElo = 2300;

let fbsTeams = [
    {fullname: "Air Force Falcons", shortname: "Air Force"},
    {fullname: "Akron Zips", shortname: "Akron"},
    {fullname: "Alabama Crimson Tide", shortname: "Alabama"},
    {fullname: "UAB Blazers", shortname: "UAB"},
    {fullname: "Appalachian State Mountaineers", shortname: "Appalachian State"},
    {fullname: "Arizona Wildcats", shortname: "Arizona"},
    {fullname: "Arizona State Sun Devils", shortname: "Arizona State"},
    {fullname: "Arkansas Razorbacks", shortname: "Arkansas"},
    {fullname: "Arkansas State Red Wolves", shortname: "Arkansas State"},
    {fullname: "Army Black Knights", shortname: "Army"},
    {fullname: "Auburn Tigers", shortname: "Auburn"},
    {fullname: "Ball State Cardinals", shortname: "Ball State"},
    {fullname: "Baylor Bears", shortname: "Baylor Bears"},
    {fullname: "Boise State Broncos", shortname: "Boise State"},
    {fullname: "Boston College Eagles", shortname: "Boston College"},
    {fullname: "Bowling Green Falcons", shortname: "Bowling Green"},
    {fullname: "Buffalo Bulls", shortname: "Buffalo"},
    {fullname: "BYU Cougars", shortname: "BYU"},
    {fullname: "California Golden Bears", shortname: "Cal"},
    {fullname: "UCLA Bruins", shortname: "UCLA"},
    {fullname: "UCF Knights", shortname: "UCF"},
    {fullname: "Central Michigan Chippewas", shortname: "Central Michigan"},
    {fullname: "Charlotte 49ers", shortname: "Charlotte"},
    {fullname: "Cincinnati Bearcats", shortname: "Cincinnati"},
    {fullname: "Clemson Tigers", shortname: "Clemson"},
    {fullname: "Coastal Carolina Chanticleers", shortname: "Coastal Carolina"},
    {fullname: "Colorado Buffaloes", shortname: "Colorado"},
    {fullname: "Colorado State Rams", shortname: "Colorado State"},
    {fullname: "Connecticut Huskies", shortname: "Connecticut"},
    {fullname: "Duke Blue Devils", shortname: "Duke"},
    {fullname: "Eastern Michigan Eagles", shortname: "Eastern Michigan"},
    {fullname: "East Carolina Pirates", shortname: "East Carolina"},
    {fullname: "FIU Panthers", shortname: "FIU"},
    {fullname: "Florida Gators", shortname: "Florida"},
    {fullname: "Florida Atlantic Owls", shortname: "Florida Atlantic"},
    {fullname: "Florida State Seminoles", shortname: "Florida State"},
    {fullname: "Fresno State Bulldogs", shortname: "Fresno State"},
    {fullname: "Georgia Bulldogs", shortname: "Georgia"},
    {fullname: "Georgia Southern Eagles", shortname: "Georgia Southern"},
    {fullname: "Georgia State Panthers", shortname: "Georgia State"},
    {fullname: "Georgia Tech Yellow Jackets", shortname: "Georgia Tech"},
    {fullname: "Hawai’i Rainbow Warriors", shortname: "Hawai’i"},
    {fullname: "Houston Cougars", shortname: "Houston"},
    {fullname: "Illinois Fighting Illini", shortname: "Illinois"},
    {fullname: "Indiana Hoosiers", shortname: "Indiana"},
    {fullname: "Iowa Hawkeyes", shortname: "Iowa"},
    {fullname: "Iowa State Cyclones", shortname: "Iowa State"},
    {fullname: "Kansas Jayhawks", shortname: "Kansas"},
    {fullname: "Kansas State Wildcats", shortname: "Kansas State"},
    {fullname: "Kent State Golden Flashes", shortname: "Kent State"},
    {fullname: "Kentucky Wilcats", shortname: "Kentucky"},
    {fullname: "LSU Tigers", shortname: "LSU"},
    {fullname: "Louisiana Tech Bulldogs", shortname: "Louisiana Tech"},
    {fullname: "Louisiana-Lafayette Ragin’ Cajuns", shortname: "Louisiana-Lafayette"},
    {fullname: "Louisiana-Monroe Warhawks", shortname: "Louisiana-Monroe"},
    {fullname: "Louisville Cardinals", shortname: "Louisville"},
    {fullname: "Marshall Thundering Herd", shortname: "Marshall"},
    {fullname: "Maryland Terrapins", shortname: "Maryland"},
    {fullname: "Massachusetts Minutemen", shortname: "Massachusetts"},
    {fullname: "Memphis Tigers", shortname: "Memphis"},
    {fullname: "Miami Hurricanes", shortname: "Miami"},
    {fullname: "Miami (OH) RedHawks", shortname: "Miami (OH)"},
    {fullname: "Michigan Wolverines", shortname: "Michigan"},
    {fullname: "Michigan State Spartans", shortname: "Michigan State"},
    {fullname: "Middle Tennessee Blue Raiders", shortname: "Middle Tennessee"},
    {fullname: "Minnesota Golden Gophers", shortname: "Minnesota"},
    {fullname: "Ole Miss Rebels", shortname: "Ole Miss"},
    {fullname: "Mississippi State Bulldogs", shortname: "Mississippi State"},
    {fullname: "Missouri Tigers", shortname: "Missouri"},
    {fullname: "Navy Midshipmen", shortname: "Navy"},
    {fullname: "Nebraska Cornhuskers", shortname: "Nebraska"},
    {fullname: "Nevada Wolf Pack", shortname: "Nevada"},
    {fullname: "UNLV Rebels", shortname: "UNLV"},
    {fullname: "New Mexico Lobos", shortname: "New Mexico"},
    {fullname: "New Mexico State Aggies", shortname: "New Mexico State"},
    {fullname: "North Carolina Tar Heels", shortname: "UNC"},
    {fullname: "NC State Wolfpack", shortname: "NC State"},
    {fullname: "North Texas Mean Green", shortname: "North Texas"},
    {fullname: "NIU Huskies", shortname: "NIU"},
    {fullname: "Northwestern Wildcats", shortname: "Northwestern"},
    {fullname: "Notre Dame Fighting Irish", shortname: "Notre Dame"},
    {fullname: "Ohio Bobcats", shortname: "Ohio"},
    {fullname: "Ohio State Buckeyes", shortname: "Ohio State"},
    {fullname: "Oklahoma Sooners", shortname: "Oklahoma"},
    {fullname: "Oklahoma State Cowboys", shortname: "Oklahoma State"},
    {fullname: "Old Dominion Monarchs", shortname: "Old Dominion"},
    {fullname: "Oregon Ducks", shortname: "Oregon"},
    {fullname: "Oregon State Beavers", shortname: "Oregon State"},
    {fullname: "Penn State Nittany Lions", shortname: "Penn State"},
    {fullname: "Pittsburgh Panthers", shortname: "Pitt"},
    {fullname: "Purdue Boilermakers", shortname: "Purdue"},
    {fullname: "Rice Owls", shortname: "Rice"},
    {fullname: "Rutgers Scarlet Knights", shortname: "Rutgers"},
    {fullname: "San Diego State Aztects", shortname: "San Diego State"},
    {fullname: "San Jose State Spartans", shortname: "San Jose State"},
    {fullname: "South Alabama Jaguars", shortname: "South Alabama"},
    {fullname: "South Carolina Gamecocks", shortname: "South Carolina"},
    {fullname: "South Florida Bulls", shortname: "South Florida"},
    {fullname: "USC Trojans", shortname: "USC"},
    {fullname: "SMU Mustangs", shortname: "SMU"},
    {fullname: "Southern Miss Golden Eagles", shortname: "Southern Miss"},
    {fullname: "Stanford Cardinal", shortname: "Standford"},
    {fullname: "Syracuse Orange", shortname: "Syracuse"},
    {fullname: "TCU Horned Frogs", shortname: "TCU"},
    {fullname: "Temple Owls", shortname: "Temple"},
    {fullname: "Tennessee Volunteers", shortname: "Tennessee"},
    {fullname: "Texas Longhorns", shortname: "Texas"},
    {fullname: "Texas A&M Aggies", shortname: "Texas A&M"},
    {fullname: "Texas State Bobcats", shortname: "Texas State"},
    {fullname: "Texas Tech Red Raiders", shortname: "Texas Tech"},
    {fullname: "UTEP Miners", shortname: "UTEP"},
    {fullname: "UTSA Roadrunners", shortname: "UTSA"},
    {fullname: "Toledo Rockets", shortname: "Toledo"},
    {fullname: "Troy Trojans", shortname: "Troy"},
    {fullname: "Tulane Green Wave", shortname: "Tulane"},
    {fullname: "Tulsa Golden Hurricane", shortname: "Tulsa"},
    {fullname: "Utah Utes", shortname: "Utah"},
    {fullname: "Utah State Aggies", shortname: "Utah State"},
    {fullname: "Vanderbilt Commodores", shortname: "Vanderbilt"},
    {fullname: "Virginia Cavaliers", shortname: "Virginia"},
    {fullname: "Virginia Tech Hokies", shortname: "Virginia Tech"},
    {fullname: "Wake Forest Demon Deacons", shortname: "Wake Forest"},
    {fullname: "Washington Huskies", shortname: "Washington"},
    {fullname: "Washington State Cougars", shortname: "Washington State"},
    {fullname: "West Virginia Mountaineers", shortname: "West Virginia"},
    {fullname: "Western Kentucky Hilltoppers", shortname: "Western Kentucky"},
    {fullname: "Western Michigan Broncos", shortname: "Western Michigan"},
    {fullname: "Wisconsin Badgers", shortname: "Wisconson"},
    {fullname: "Wyoming Cowboys", shortname: "Wyoming"}
];

const kMaxWeek = 16;
const kPostSeasonWeek = kMaxWeek + 1;
let gameDisplayList = null;
let displayWeek = -1;
let currentWeek = -1;
let calendarData, gameData, rankingData, bettingData, teamData, postSeasonBetting, playTypes, bowlData, playsData;
let espnScoreboardData = null;
let espnScoreboardDataByWeek = [];

let viewFilterControl = null;
let searchBoxControl = null;
let searchClearButton = null;

// const axios = require('axios');

// call & parse both API endpoints
const urls = [
    // apiEndpoint + "/events?" + apiKey,
    // apiEndpoint + "/odds?regions=us&markets=spreads&oddsFormat=american&bookmakers=draftkings&" + apiKey,


    // "https://w2w.dave-hill.workers.dev/api/data/events/",
    // "https://w2w.dave-hill.workers.dev/api/data/odds/",


    "./eventData.json",
    "./spreadData.json"


]

const cfbApiKey = 'null'; //'/khF67ocBsAsl0aTOO/4xh2p+zpjHp/g3NuVdapNZPbAUUDEjiOhVDFmEfSPJqJF';

const proxyRequestHeaders = new Headers();
proxyRequestHeaders.append("Authorization", `Bearer ${cfbApiKey}`);
proxyRequestHeaders.append("Content-Type", "application/json");

const espnProxyRequestHeaders = new Headers();
proxyRequestHeaders.append("Content-Type", "application/json");

// let cfbApiUrl = 'https://api.collegefootballdata.com/games?year=2024&seasonType=regular&week=5';
// cfbApiUrl = 'https://api.collegefootballdata.com/games?year=2024&week=5&division=fbs';
// cfbApiUrl = 'https://api.collegefootballdata.com/lines?year=2024'; // Betting odds
// // cfbApiUrl = 'https://api.collegefootballdata.com/calendar?year=2024'; // Weekly calendar rnages
// cfbApiUrl = 'https://api.collegefootballdata.com/rankings?year=2024';

function getProxiedRequestPromise(urlString)
{
    const proxyURL = 'https://hidden-sun-6344.dave-hill.workers.dev/corsproxy/?apiurl=';

    let proxiedUrl = proxyURL + urlString;
    let promise = fetch(proxiedUrl, {headers: proxyRequestHeaders}).then(response => {
            if (!response.ok) { // Check for fetch errors
                throw new Error(`Error fetching ${[proxiedUrl]}: ${response.status}`);
            }
            return response.json();
        });

    return promise;
}

function getLocalFile(urlString)
{
    let promise = fetch(urlString).then(response => {
        if (!response.ok) {
            throw new Error(`Error fetching ${urlString}: ${response.status}`);
        }
        return response.json();
    });

    return promise;
}

function computeNthQuarterScore(scoreline, n)
{
    let result = 0;
    for (let i = 0; i < n; i++)
    {
        result += scoreline[i].value;
    }
    return result;
}

function computeLeaderFromPoints(awayScore, homeScore)
{
    let leader = -1;

    if (homeScore == awayScore)
        leader = 0;
    else if (homeScore > awayScore)
        leader = 2;
    else
        leader = 1;

    // console.log("Leader: " + leader + " ==> " + awayScore + ", " + homeScore);
    return leader;
}

function computeNthQuarterLeader(awayScores, homeScores, n)
{
    console.assert(1 <= n && n <= homeScores.length);
    let homePoints = 0, awayPoints = 0;
    for (let i = 0; i < n; i++)
    {
        homePoints += homeScores[i];
        awayPoints += awayScores[i];        
    }

    return computeLeaderFromPoints(awayPoints, homePoints);
    
}


let dateNow = new Date(Date.now());

let year = 2024;

let queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.has('year'))
{
    year = parseInt(urlParams.get('year'));
}
else
{
    if (dateNow.getMonth() < 3) // dates are 0-based, so January is 0, February is 1, March is 2
        year = dateNow.getFullYear() - 1; // If before April, use last year
    else
        year = dateNow.getFullYear(); // Otherwise, use this year
}

let promises = [];

promises.push(getLocalFile('./teamData.json'));
promises.push(getProxiedEspnRequestPromise(`https://sports.core.api.espn.com/v2/sports/football/leagues/college-football/calendar/ondays`));

Promise.all(promises)
    .then(results => {
        // Handle results

        teamData = results[0];
        calendarData = results[1];

        getGameEventsForWeek(null);

    })
    .catch(error => {
        console.error('Error loading startup data:', error);
        let message = document.createElement('p');
        message.className = 'load-error';
        message.textContent = "Couldn't load game data. Please try refreshing the page.";
        document.getElementById('list-container').prepend(message);
    });



    if (false)
    {
        document.getElementById("firebuttonid").onclick = () => {
            gameDisplayList.search("\u{1F525}")
        }

        document.getElementById("rankbuttonid").onclick = () => {

            gameDisplayList.search( 'xxx', () => {
            for (var k = 0, kl = gameDisplayList.items.length; k < kl; k++) {
                let item = gameDisplayList.items[k]
                item.found = false;
                let gameitem = item.values().gameitem;
                if (gameitem.awayRank <= 25 || gameitem.homeRank <= 25)
                    item.found = true;
                // Insert your custom search logic here, set found = true
        
            }});
        }

        document.getElementById("futurebuttonid").onclick = () => {

            gameDisplayList.search( 'xxx', () => {
            for (var k = 0, kl = gameDisplayList.items.length; k < kl; k++) {
                let item = gameDisplayList.items[k]
                item.found = false;
                let gameitem = item.values().gameitem;
                if (!gameitem.completed && !gameitem.skip)
                    item.found = true;
                // Insert your custom search logic here, set found = true
        
            }});
        }

        document.getElementById("allbuttonid").onclick = () => {
            gameDisplayList.search('');
        }
        // document.onload = () => {
            document.getElementById('prevweekbuttonid').onclick = () => {onChangeWeek( -1 )};
            document.getElementById('nextweekbuttonid').onclick = () => {onChangeWeek( 1 )};
        // }
    }
    else
    {
        if (viewFilterControl == null)
            viewFilterControl = document.getElementById("view_filter");

        viewFilterControl.onclick = (_event) => {
            _event.preventDefault(); // for some reason, without this it was triggering a full page reload
        };

        viewFilterControl.onchange = (_event) => {
            viewFilterChanged();
        };

        document.getElementById('prevweekbuttonid').onclick = (event) => {
            event.preventDefault(); // for some reason, without this it was triggering a full page reload
            onChangeWeek( -1 )
        };
        document.getElementById('nextweekbuttonid').onclick = (event) => {
            event.preventDefault(); // for some reason, without this it was triggering a full page reload
            onChangeWeek( 1 )
        };

        searchBoxControl = document.getElementById('search_box');
        searchClearButton = document.getElementById('clear_search');

        searchClearButton.onclick = () => {
            searchBoxControl.value = '';
            gameDisplayList.search('');
            searchClearButton.classList.toggle('show', false);
        }

        searchBoxControl.addEventListener('input', () => {
            searchClearButton.classList.toggle('show', searchBoxControl.value.trim() !== '');
        });
    }
    


    function getGameEventsForWeek(_week)
    {
        let gamePromises = [];
        let matchingWeekEntry = null;
        let startOfWeek = null;
        let endOfWeek = null;

        for (let section of calendarData.sections)
        {
            for (let entry of section.entries)
            {
                let startDate = new Date(Date.parse(entry.startDate));
                let endDate = new Date(Date.parse(entry.endDate));
                if (_week === null)
                {


                    if (startDate <= dateNow && dateNow <= endDate)
                    {
                        // @TODO - figure out how to handle postseason at some point

                        matchingWeekEntry = entry;
                        startOfWeek = startDate;
                        endOfWeek = endDate;
                        currentWeek = parseInt(entry.value);


                        // @TODO'26 - I'm not sure what I was thinking with post-season, but the below code seems to hose
                        // the 'getGameEventsForWeek(null) call at startup. Disabling it for now... will likely need to
                        // revisit closer to preseason 2026/2027

                        /*let isBowlSeason = section.label.localeCompare("Postseason") == 0;
                        console.assert(isBowlSeason, "Currently only handling postseason as the null week case");
                        currentWeek = kPostSeasonWeek;
                        */
                        break;
                    }
                }
                else
                {
                    console.assert(1 <= _week && _week <= 16);
                    // find the week that matches the _week number passed in
                    if (parseInt(entry.value) === _week)
                    {
                        matchingWeekEntry = entry;
                        startOfWeek = startDate;
                        endOfWeek = endDate;
                        currentWeek = _week;
                        break;
                    }
                }
            }
            if (matchingWeekEntry !== null)
            {
                break;
            }
        }

        if (currentWeek !== -1) // We have found a valid week (was `if (_week !== null)`)
        {
            // Iterate over every day in the week and issue a separate request for the games on that day in YYYYMMDD format
            for (let d = startOfWeek; d <= endOfWeek; d.setDate(d.getDate() + 1))
            {
                let dateString = d.toISOString().split('T')[0].replace(/-/g, '');
                console.log("Date = " + dateString);
                gamePromises.push(getProxiedEspnRequestPromise(`https://site.api.espn.com/apis/site/v2/sports/football/college-football/scoreboard?groups=80&dates=${dateString}&limit=500`));
            }
        }
        else
        {
            // postseason - just get all bowl games
            gamePromises.push(getProxiedEspnRequestPromise(`https://site.api.espn.com/apis/site/v2/sports/football/college-football/scoreboard?groups=80&limit=500`));
        }

        Promise.all(gamePromises)
            .then(results => {

                espnScoreboardData = [];
                for (let result of results)
                {
                    espnScoreboardData.push(...result.events);
                }

                const uniqueById = espnScoreboardData.filter((obj, index, array) => {
                    // Check if the current object's index is the same as the first time
                    // an object with the same 'id' appears
                    return espnScoreboardData.findIndex(
                        (item) => item.id.localeCompare(obj.id) === 0
                    ) === index;
                })

                espnScoreboardData = uniqueById;
                console.log("Found " + espnScoreboardData.length + " events");
                
                //  Postseason resets to week 1. For now, just move all of these to "week 16"
                if (false) {
                    bettingData.forEach((entry) => {
                        if (entry.week == 1 && entry.seasonType.localeCompare("postseason") == 0) {
                            entry.week = kMaxWeek;
                        }
                    })
                    console.log(JSON.stringify(gameData));

                    //  Postseason resets to week 1. For now, just move all of these to "week 16"
                    gameData.forEach((entry) => {
                        if (entry.week == 1 && entry.seasonType.localeCompare("postseason") == 0) {
                            // console.log("rewriting week for playoff game between " + entry.awayTeam + " @ " + entry.homeTeam );
                            entry.week = kMaxWeek;
                        }
                    })

                    // walk through weeks until we find the one that starts after today -- we're in the week before that
                    for (let i = 0; i < calendarData.length; i++) {
                        let week = calendarData[i];
                        let startDate = new Date(Date.parse(week.firstGameStart));
                        startDate.setDate(startDate.getDate() - 1);
                        // let endDate = new Date(Date.parse(week.lastGameStart));
                        // endDate.setDate(endDate.getDate()+1);

                        if (startDate > dateNow)
                            break;

                        currentWeek = week.week;
                        if (week.seasonType.localeCompare("postseason") == 0) {
                            currentWeek = kMaxWeek;
                        }

                        // if (startDate <= today && today <= endDate)
                        // {
                        //     currentWeek = week.week;
                        //     break;
                        // }
                    }
                }
                else {
                    // currentWeek = espnScoreboardData[0]?.week?.number;
                    console.assert(currentWeek != null);
                    espnScoreboardDataByWeek[currentWeek] = espnScoreboardData;
                }

                console.log(
                    "week number = " + currentWeek
                );

                // currentWeek = 6;


                // updateListForWeek(currentWeek);
                displayWeek = currentWeek;
                if (urlParams.has('week')) {
                    displayWeek = parseInt(urlParams.get('week'));
                }
                onChangeWeek(0);



            })
            .catch(error => console.error('Error:', error));
    }
// function firebutton()
// {
//     let textfield = getElementById("search_box");
//     textfield.setAttribute('value', "\u{1F525}");
// }

function onChangeWeek(increment)
{
    displayWeek = displayWeek + increment;
    let prevButton = document.getElementById('prevweekbuttonid');
    let nextButton = document.getElementById('nextweekbuttonid');

    if (displayWeek <= 1)
    {
        displayWeek = 1;
        prevButton.disabled = true;
    }
    else if (displayWeek >= kPostSeasonWeek)
    {
        displayWeek = kPostSeasonWeek;
        nextButton.disabled = true;
    }
    else
    {
        nextButton.disabled = false;
        prevButton.disabled = false;
    }

    document.getElementById('weeklabelid').innerHTML = "Week " + displayWeek;

    if (espnScoreboardDataByWeek[displayWeek])
        updateListForWeek(displayWeek);
    else
    {
        //@TODO - clear the view
        if (gameDisplayList != null)
        {
            gameDisplayList.clear();
        }

        getGameEventsForWeek(displayWeek);

        //@TODO - update to handle requesting day-by-day results
        // getProxiedEspnRequestPromise(`https://site.api.espn.com/apis/site/v2/sports/football/college-football/scoreboard?week=${displayWeek}&groups=90`).then( (data) => {
        //     console.assert(data != null, "failed to retrieve scoreboard data for week " + displayWeek);
        //     espnScoreboardDataByWeek[displayWeek] = data;
        //     updateListForWeek(displayWeek);
        // });
    }

    viewFilterChanged(); // re-apply the view filter based on the current value
}

function probabilityOfWinning(_moneyline)
{
    if (_moneyline < 0)
    {
        return _moneyline / (_moneyline - 100);
    }
    else
    {
        return 100 / (_moneyline + 100);
    }
}

function clamp(_value, _min, _max)
{
    return Math.min(Math.max(_min, _value), _max);
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function computeWatchability(game, gameEntry, espnData)
{
    let result = {
        watchability: "???",
        skip: false
    };

    // console.log("computeWatchability for " + gameEntry.awayTeam + " @ " + gameEntry.homeTeam);

    let homeCompetitor = gameEntry.homeCompetitor;
    let awayCompetitor = gameEntry.awayCompetitor;

    let pointDifferential = Math.abs(homeCompetitor.score - awayCompetitor.score);
    // let totalPoints = homeCompetitor.score + awayCompetitor.score;
    let endOfRegulationTotalPoints = computeNthQuarterScore(homeCompetitor.linescores, 4) + computeNthQuarterScore(awayCompetitor.linescores, 4);

    // let watchForPoints = pointDifferential < 17; // two score game

    // let excitementIndex = game.excitement_index ?? 0.0;

    // Check for mayhem
    let homeWin = homeCompetitor.winner;
    let winnerRank = homeWin ? gameEntry.homeRank : gameEntry.awayRank;
    let loserRank = homeWin ? gameEntry.awayRank : gameEntry.homeRank;

    let winnerScore = homeWin ? homeCompetitor.score : awayCompetitor.score;
    let loserScore = homeWin ? awayCompetitor.score : homeCompetitor.score;

    let watchForMayhem = winnerRank > loserRank; // lower rank number == higher number, so if loser rank is greater than winner, it's mayhem

    let watchForOvertime = homeCompetitor.linescores.length > 4;

    let watchFor4thQuarterComeback = false;
    let fourthQuarterComebackGap = 0;
    if (!watchForOvertime) {
        // check for a 4th quarter comeback
        let home3rdQuarterScore = computeNthQuarterScore(homeCompetitor.linescores, 3);
        let away3rdQuarterScore = computeNthQuarterScore(awayCompetitor.linescores, 3);
        let winnerThirdQuarterScore = homeWin ? home3rdQuarterScore : away3rdQuarterScore;
        let loserThirdQuarterScore = homeWin ? away3rdQuarterScore : home3rdQuarterScore;

        watchFor4thQuarterComeback = loserThirdQuarterScore > winnerThirdQuarterScore;

        if (watchFor4thQuarterComeback) {
            fourthQuarterComebackGap = (homeWin ? game.homePoints : game.awayPoints) - winnerThirdQuarterScore;

            // 4th quarter comeback gap should be "how much were we losing by at end of 3rd" vs. "how much were we winning by at end of 4th"
            // Or, how much were we down by at end of third

            fourthQuarterComebackGap = (loserThirdQuarterScore - winnerThirdQuarterScore) + (winnerScore - loserScore);
        }
    }

    if (pointDifferential < 17) // delta is max of two-score game... otherwise skip
    {
        let watchabilityScore = 0.0;

        let pointDifferentialScore = 1.0 - Math.min((pointDifferential - 1) / 16, 1.0); // smaller point differential yields higher score
        pointDifferentialScore *= pointDifferentialScore; // squaring a 0..1 number makes numbers closer to one (i.e., smaller differential) get rated higher
        let overtimeScore = watchForOvertime ? 1 : 0;
        let fourthQuarterComebackScore = watchFor4thQuarterComeback ? Math.min(fourthQuarterComebackGap / 21, 1.0) : 0;
        let lotsOfScoringScore = Math.min(endOfRegulationTotalPoints / 70.0, 1.0);
        let mayhemScore = watchForMayhem ? (0.25 + 0.75 * Math.min((winnerRank - loserRank) / 25, 1.0)) : 0;
        let top10MayhemScore = (loserRank) <= 10 ? 0.5 : 0;
        let top5MayhemScore = (loserRank) <= 5 ? 0.5 : 0;

        let perQuarterExcitementScores = 0.0;

        // compute how exciting each quarter is (i.e., how much scoring)
        for (let i = 0; i < 4; i++) // omit overtime
        {
            let pointsInQuarter = homeCompetitor.linescores[i].value + awayCompetitor.linescores[i].value;
            if (pointsInQuarter > 9) // if there's some minimum threshold of scoring in the quarter, we give it some weight
            {
                perQuarterExcitementScores += Math.min(pointsInQuarter / 28, 1.0) * 0.25;
            }
        }

        // compute how many lead changes
        let perQuarterLeadChanges = 0;
        
        // console.log("Leader Q1: " + leader);
        let leadChanges = 0;
        let winProbabilityChanges = 0;

        let noData = false;

        if (espnData !== null && espnData.length > 0) // compute lead changes from ESPN data
        {
            let leader = computeLeaderFromPoints(espnData[0].homePoints, espnData[0].awayPoints);
            let currentWinProbability = espnData[0].homeWinPercentage * 100.0 - 50.0; // 50% is the baseline, so we subtract it to get a range of -50 to +50
            for (let i = 1; i < espnData.length; i++) {
                let newLeader = computeLeaderFromPoints(espnData[i].homePoints, espnData[i].awayPoints);
                // console.log("Leader Q" + (i+1) + ": " + leader);

                if (newLeader != leader) {
                    leadChanges++;
                    leader = newLeader;
                }
                let newWinProbability = espnData[i].homeWinPercentage * 100.0 - 50.0;
                let delta = newWinProbability - currentWinProbability;
                winProbabilityChanges += Math.abs(delta);
                currentWinProbability = newWinProbability;
                // console.log("Win Prob Changes: " + delta);
            }

        }
        else
        {
            console.warn("No ESPN data for " + gameEntry.awayTeam + " @ " + gameEntry.homeTeam + ", using simplified lead change computation");
            noData = true;

            
            result.skip = false;
            result.watchability = "⚠️"; // yellow circle, no data
            return result;
            // Fall back to old way of computing lead changes
            let leader = computeNthQuarterLeader(game.awayLineScores, game.homeLineScores, 1);
            for (let i = 2; i <= game.awayLineScores.length; i++) {
                let newLeader = computeNthQuarterLeader(game.awayLineScores, game.homeLineScores, i);
                // console.log("Leader Q" + i + ": " + leader);

                if (newLeader != leader) {
                    leadChanges++;
                    leader = newLeader;
                }
            }
        }
        // console.log("Lead Changes: " + leadChanges);
        // console.log("Win Probability Changes: " + winProbabilityChanges);

        // compute how close the game is throughout

        let closeThroughoutScore = 0.0;
        for (let i = 1; i <= 4; i++) {
            let perQuarterDiff = Math.abs(computeNthQuarterScore(homeCompetitor.linescores, i) - computeNthQuarterScore(awayCompetitor.linescores, i));
            closeThroughoutScore += 0.25 * Math.max(1.0 - perQuarterDiff / 16, 0.0);
        }


        let leadChangeDenominator = espnData ? 6 : 4;
        watchabilityScore =
            (mayhemScore + top10MayhemScore + top5MayhemScore) * 1.25 +
            overtimeScore * 1.0 +
            pointDifferentialScore * 1.0 +
            closeThroughoutScore * 0.85 +
            fourthQuarterComebackScore * 0.75 +
            perQuarterExcitementScores * 0.5 +
            lotsOfScoringScore * 0.5 +
            (leadChanges / leadChangeDenominator) * 0.5 + 
            (winProbabilityChanges / 50.0) * 0.35;

        // stack rank
        // mayhem **
        // overtime **
        // close game **
        // close throughout 0.5
        // 4th quarter comeback 0.5
        // scoring throughout the game 0.5
        // lots of scoring 0.5
        // lead changes 0.5

        let fires = Math.ceil(clamp(watchabilityScore * 1.0 * (3 / 5), 1, 3)); //Math.ceil((watchabilityScore / 5) * 3); // 1, 2, or 3

        result.skip = false;
        result.watchability = "";
        for (let i = 0; i < fires; i++) {
            result.watchability += "\u{1F525}";
            // if ((fires == 4 && i == 1) || (fires == 5 && i == 2))
            //     watchability += "<br class='br_mobile_only'>";
        }
        // watchability += " " + watchabilityScore.toFixed(1).toString();
        // console.log(
        //     game.awayTeam + " vs " + game.homeTeam + "\n" +
        //     "point diff: " + pointDifferentialScore.toFixed(2).toString() + "\n" + 
        //     "overtime: " + overtimeScore.toString() + "\n" + 
        //     "4th Quarter comeback: " + fourthQuarterComebackScore.toFixed(2).toString() + "\n" + 
        //     "Scoring: " + lotsOfScoringScore.toFixed(2).toString() + "\n" + 
        //     "Per Quarter: " + perQuarterExcitementScores.toFixed(2).toString() + "\n" + 
        //     "Lead Changes: " + (leadChanges / 4).toFixed(2).toString() + "\n" + 
        //     "Mayhem: " + mayhemScore.toFixed(2).toString()
        // );

    }
    else {
        // watchability = "Skip";
        result.watchability = "\u{274C}";
        result.skip = true;
    }

    return result;
}

function computePreGameWatchability(game, gameEntry, espnData)
{
    let result = {
        watchability: "???",
        skip: true
    };

    let odds = (game.competitions[0].odds?.length > 0 ? game.competitions[0].odds[0] : null);
    let spread = odds ? Math.abs(odds.spread) : null;

    let skip = (spread && spread > 17);
    let watchability = "No Data";
    let espnDataAvailable = (espnData != null) && espnData.length == null; // empty data has length == 0, non-empty data doesn't have a null field
    const kMaxDelta = 50;

    if (skip) {
        watchability = "Skip";
    }
    else if (spread || espnData) {

        let balls = 0;

        if (spread)
        {
            let competitiveness = 1 - (spread / 17);

            /*
            let elo1 = clamp(game.awayPregameElo, kMinElo, kMaxElo);
            let elo2 = clamp(game.homePregameElo, kMinElo, kMaxElo);
            let teamStrength = (elo1 + elo2) / 2;
            teamStrength = (teamStrength - kMinElo) / (kMaxElo - kMinElo);
            */
            let teamStrength = 0;


            // let favoriteOdds = Math.min(gameBettingData.lines[0].homeMoneyline, gameBettingData.lines[0].awayMoneyline);
            let favoriteOdds = 0;
            if (odds.moneyline.home.close == null || odds.moneyline.away.close == null) {
                favoriteOdds = Math.min(parseInt(odds.moneyline?.home?.open?.odds), parseInt(odds.moneyline?.away?.open?.odds));
            }
            else {
                favoriteOdds = Math.min(parseInt(odds.moneyline?.home?.close?.odds), parseInt(odds.moneyline?.away?.close?.odds));
            }

            let uncertainty = 0;
            /*if (!isNaN(favoriteOdds)) {
                let favoriteProbOfWinning = probabilityOfWinning(favoriteOdds); // even odds is 50-50, and goes up from there
                console.assert(favoriteProbOfWinning >= 0.5);
                uncertainty = 1.0 - 2.0 * (favoriteProbOfWinning - 0.5); // convert to a 0..1 value
            }
            */
           // Delta ranges from 0 to 100.
           uncertainty = 1.0 - (Math.max(Math.min(espnData.delta, kMaxDelta), 0) / kMaxDelta);
        //    uncertainty *= uncertainty;
           // uncertainty = 1.0 - (espnData.delta*0.01); // convert to a 0..1 value -- 0 == 50-50, 100 = total blowout

            let highScoring = odds.overUnder ? clamp((odds.overUnder - 10) / (70 - 10), 0, 1) : 0;

            let highStakesMultiplier = 1.0;
            if (game.competitions[0].conferenceCompetition) {
                highStakesMultiplier += 0.1;
            }
            if (gameEntry.awayRank < 25 && gameEntry.homeRank < 25) {
                highStakesMultiplier += 0.1;
            }

            let watchScore = 0;
            if (uncertainty > 0)
            {
                watchScore = (competitiveness + teamStrength + uncertainty * 1.3 + highScoring) * highStakesMultiplier;
            }

            balls = Math.round(clamp(watchScore, 0, 3)); // * 1.5 * (3 / 10), 0, 3));   

            watchability = "";
            if (false && espnData)
            {
                watchability = espnData.delta.toFixed(0) + " ";
                watchability += "<br>comp: " + competitiveness.toFixed(1);
                // watchability += "<br>team: " + teamStrength.toFixed(1);
                watchability += "<br>uncert: " + uncertainty.toFixed(1);
                watchability += "<br>score: " + highScoring.toFixed(1);
                watchability += "<br>stakes: " + highStakesMultiplier.toFixed(1);
                watchability += "<br>total: " + watchScore.toFixed(1);
            }
        }
        else if (espnData.delta != null)
        {
            
            let uncertainty = 1.0 - (Math.max(Math.min(espnData.delta, kMaxDelta), 0) / kMaxDelta);
            balls = clamp(Math.round(uncertainty*3), 0, 3); //Math.ceil(clamp(100 - espnData.delta) / 33, 1, 3);

            /*if (espnData.delta > 75)
            {
                balls = -1;
            }
            else
            {
                balls = Math.ceil(clamp(100 - espnData.delta) / 33, 1, 3);
            }
            */

            // watchability = "XX " + espnData.delta.toFixed(0) + " ";
            watchability = "";

        }
        else
        {
            watchability = "No Data";
            skip = false;
        }
        if (balls > 0)
        {
            for (let i = 0; i < balls; i++) {
                watchability += "\u{1F52E}";
                if ((balls == 4 && i == 1) || (balls == 5 && i == 2))
                    watchability += "<br class='br_mobile_only'>";
            }
            skip = false;
        }
        else if (espnDataAvailable)
        {
            watchability = "Skip";
            skip = true;
        }

        // if (watchScore > 3.25)
        // {
        //     watchability = "\u{1F52E}\u{1F52E}\u{1F52E}";
        // }
        // else if (watchScore > 2.4)
        // {
        //     watchability = "\u{1F52E}\u{1F52E}";
        // }
        // else
        // {
        //     watchability = "\u{1F52E}";
        // }
    }
    else
    {
        watchability = "No Data";
        skip = false;
    }
    result.watchability = watchability;
    result.skip = skip;

    return result;
}

// True if the game belongs to the week currently on screen (the user may have changed weeks while data was loading).
function isGameInDisplayedWeek(_game)
{
    if (displayWeek < 17)
        return displayWeek == _game.week.number;
    return _game.season.type == 3; // week 17 == postseason
}

// Pushes a watchability result into the game's row in the list.
function updateGameWatchability(_id, _gameEntry, result)
{
    let gameListEntry = gameListValues.find((entry) => (entry.id == _id));
    let item = gameDisplayList.get('id', _id);
    if (gameListEntry == null || item == null || item.length != 1)
    {
        console.warn("Game not found in the list: " + _id + " => " + _gameEntry.awayTeam + " @ " + _gameEntry.homeTeam);
        return;
    }

    item[0].values({
        watchability: result.watchability,
        skip: result.skip
    });
    gameListEntry.watchability = result.watchability;
    gameListEntry.skip = result.skip;
    _gameEntry.skip = result.skip;
}

// After `delayMs` (requests are staggered so we don't flood ESPN), calls `rateGame` -- which returns a promise of
// { watchability, skip } -- and updates the game's row with the result.
function scheduleWatchabilityUpdate(_game, _gameEntry, delayMs, rateGame)
{
    delay(delayMs)
        .then(() => {
            if (!isGameInDisplayedWeek(_game))
                return null;
            console.log("Fetching ESPN data for " + _gameEntry.awayTeam + " @ " + _gameEntry.homeTeam + " (" + _game.id + ")");
            return rateGame();
        })
        .then((result) => {
            if (result == null || !isGameInDisplayedWeek(_game))
                return;
            updateGameWatchability(_game.id, _gameEntry, result);
        })
        .catch((error) => console.error("Error rating game " + _game.id + ":", error));
}

// Rates a game that's in progress with a spoiler-free face (see liveWatchability.js). Early in the game there isn't
// enough to go on, so it just says "In Progress".
function rateLiveGame(_game, _gameEntry)
{
    return getLiveSnapshotEspn(_game.id).then((snapshot) => {
        if (snapshot == null)
            return { watchability: "⚠️", skip: false }; // no data

        // Too early to tell -- and the pre-game rating isn't a good guide once the game has started.
        if (snapshot.elapsedMin < kLiveEarlyGameMinutes)
            return { watchability: "In Progress", skip: false };

        // ESPN drops the matchup predictor once a game starts, so use it only if it was cached before kickoff;
        // otherwise the snapshot has the pre-game win chance from the closing betting line.
        let pregame = getCachedMatchupPredictionEspn(_game.id);
        let pregameHomeWin = parseFloat(pregame?.homeTeamWin) / 100;
        if (isNaN(pregameHomeWin))
            pregameHomeWin = snapshot.pregameHomeWin;

        return computeLiveWatchability(snapshot, {
            homeRank: _gameEntry.homeRank,
            awayRank: _gameEntry.awayRank,
            pregameHomeWin: pregameHomeWin
        });
    });
}

// Keep a list of games that can be updated and then pushed back into the list again
let gameListValues = [];

function updateListForWeek(_week)
{
    displayWeek = _week;
    gameListValues = [];

    // let filteredGames = gameData.filter((game) => (game.week == displayWeek && (game.awayClassification === "fbs" || game.homeClassification === "fbs")));
    // let filteredRanking = rankingData.find((entry) => (entry.week == displayWeek));
    // let filteredBettingData = bettingData.filter((entry) => (entry.week == displayWeek));

    let filteredGames = espnScoreboardDataByWeek[displayWeek] ?? [];



    const gameListDiv = document.getElementById('game-list');

    let games = [];
    if (false)
    {
        let rankingPoll = null;
        if (filteredRanking && filteredRanking.polls)
        {
            rankingPoll = filteredRanking.polls.find((entry) => (entry.poll == "Playoff Committee Rankings"));
            if (!rankingPoll)
            {
                rankingPoll = filteredRanking.polls.find((entry) => (entry.poll == "AP Top 25"));
                // console.assert(rankingPoll);
                if (rankingPoll)
                    console.log("Using AP Poll Rankings");
                else 
                {
                    rankingPoll = filteredRanking.polls.find((entry) => (entry.poll == "Coaches Poll"));
                    if (rankingPoll)
                        console.log("Using Coaches Poll Rankings");
                    else
                        console.log("No rankings found for week " + displayWeek);
                }
            }
            else
            {
                console.log("Using CFB Rankings");
            }
        }
    }

    let game;
    let delayCounter = 0;
    let initialDelay = 500;
    for (game of filteredGames) {

        if (Object.keys(game).length === 0) {
            console.log("Skipping empty game object");
            continue;
        }

        let date = new Date(Date.parse(game.date));

        console.assert(game.competitions.length == 1);


        let homeCompetitor = game.competitions[0].competitors.find((entry) => (entry.homeAway == "home"));
        let awayCompetitor = game.competitions[0].competitors.find((entry) => (entry.homeAway == "away"));

        let isHomeTBD = homeCompetitor.team.displayName.localeCompare("TBD") == 0;
        let isAwayTBD = awayCompetitor.team.displayName.localeCompare("TBD") == 0;
        
        let awayTeam = teamData.find((entry) => (entry.id == awayCompetitor.id));
        let homeTeam = teamData.find((entry) => (entry.id == homeCompetitor.id));

        if ((awayTeam == undefined && !isAwayTBD) && (homeTeam == undefined && !isHomeTBD)) {
            console.log("Skipping: " + awayCompetitor.team.displayName + " @ " + homeCompetitor.team.displayName + " because both teams are missing from the team data");
            continue;
        }
        if ((homeCompetitor.team.logo == null && !isHomeTBD) || (awayCompetitor.team.logo == null && !isAwayTBD)) {
            console.log("Skipping: " + awayCompetitor.team.displayName + " @ " + homeCompetitor.team.displayName + " because one of the teams is missing a logo");
            continue;
        }


        let gameEntry = {
            date: date,
            homeTeam: homeCompetitor.team.shortDisplayName,
            awayTeam: awayCompetitor.team.shortDisplayName,
            week: _week,
            homeCompetitor: homeCompetitor,
            awayCompetitor: awayCompetitor
        };

        gameEntry.homeRank = parseInt(homeCompetitor.curatedRank.current);
        gameEntry.awayRank = parseInt(awayCompetitor.curatedRank.current);

        /*if (rankingPoll)
        {
            gameEntry.homeRank = rankingPoll.ranks.find((entry) => (entry.school == game.homeTeam));
            if (gameEntry.homeRank != null)
                gameEntry.homeRank = gameEntry.homeRank.rank;
            else
                gameEntry.homeRank = 1000;

            gameEntry.awayRank = rankingPoll.ranks.find((entry) => (entry.school == game.awayTeam));
            if (gameEntry.awayRank != null)
                gameEntry.awayRank = gameEntry.awayRank.rank;
            else
                gameEntry.awayRank = 1000;
            
        }
        else
        {
            gameEntry.homeRank = 1000;
            gameEntry.awayRank = 1000;
        }
        */







        let watchability = "???";
        let skip = true;
        gameEntry.completed = Boolean(game.status?.type?.completed) ?? false;

        // Ratings that need ESPN game data are fetched in the background (see scheduleWatchabilityUpdate); until
        // they arrive the row shows "...".
        let _id = game.id;
        let _game = game;
        let _gameEntry = gameEntry;
        let rateGame = null;

        if (game.status?.type?.completed)
        {
            let pointDifferential = Math.abs(homeCompetitor.score - awayCompetitor.score);
            if (pointDifferential < 17) // two score game
            {
                rateGame = () => getScoringDrivesEspn(_id).then((espnData) => computeWatchability(_game, _gameEntry, espnData ?? null));
            }
            else
            {
                watchability = "\u{274C}"; // red X
                skip = true;
            }
        }
        else if (game.status?.type?.state === "in") // includes halftime; delayed games are still "pre"
        {
            rateGame = () => rateLiveGame(_game, _gameEntry);
        }
        else
        {
            rateGame = () => getMatchupPredictionEspn(_id).then((espnData) =>
                (espnData != null) ? computePreGameWatchability(_game, _gameEntry, espnData) : { watchability: "No Data", skip: false });
        }

        if (rateGame != null)
        {
            watchability = "...";
            skip = false;
            scheduleWatchabilityUpdate(_game, _gameEntry, initialDelay + delayCounter * 250, rateGame);
            delayCounter++;
            initialDelay = 0; // only delay the first one by initialDelay, subsequent ones are just delayCounter * 250
        }
        // get ranking

            // let dateString = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'short' }).format(date);

        gameEntry.spread = watchability;// ? "watch" : "skip";
        // gameEntry.completed = game.completed;
        gameEntry.skip = skip;
        gameEntry.away_id = awayCompetitor.id;
        gameEntry.home_id = homeCompetitor.id;
        gameEntry.id = game.id;

        if (game.competitions[0].notes && game.competitions[0].notes.length > 0)
        {
            let gameNotes = game.competitions[0].notes[0].headline;
            if (gameNotes.indexOf("College Football Playoff") >= 0 ||
                gameNotes.indexOf("Championship") >= 0)
            {
                gameEntry.bowl_title = "\u{1F3C6} <i>" + gameNotes + "</i>";
            }
            else
            {
                gameEntry.bowl_title = "<i>" + gameNotes + "</i>";
            }
        }
        else
            gameEntry.bowl_title = '';

        games.push(gameEntry);
    }

    // sort entries
    games.sort((a,b) => {
        
        if (a.date.getTime() === b.date.getTime() )
        {
            let aRankedOnRanked = a.awayRank < 26 && a.homeRank < 26;
            let bRankedOnRanked = b.awayRank < 26 && b.homeRank < 26;
            let aOneRanked = a.awayRank < 26 || a.homeRank < 26;
            let bOneRanked = b.awayRank < 26 || b.homeRank < 26;

            let aMaxRank = Math.min(a.awayRank, a.homeRank);
            let bMaxRank = Math.min(b.awayRank, b.homeRank);

            if (aRankedOnRanked != bRankedOnRanked)
            {
                return aRankedOnRanked ? -1 : 1;
            }
            if (aOneRanked != bOneRanked)
            {
                return aOneRanked ? -1 : 1;
            }

            return a.awayTeam.localeCompare(b.awayTeam); // < b.awayTeam;
            // if (a.awayRank < 25 && a.homeRank < 25)
            // let val = a.spread - b.spread;
            // return val;
        }
        return a.date - b.date;
    });

        // games = games.sort();
        // shuffleArray(games);
      
    

    var options = {
        // template: '<h2>{{category}}</h2><ul>{{#items}}<li>{{name}}</li>{{/items}}</ul>',
        item: 'game-list-item',
        // item: function(item) {
        //     let element = document.getElementById('game-list-item');
        //     return element.cloneNode(true);
        // },
        valueNames: [
            'week_date_header',
            'bowl_game_title',
            // {name:'away_team_logo', attr:'src'},
            'away_team_logo',
            'away_team_name', 
            'away_team_shortname', 
            'at_sign',
            // {name:'home_team_logo', attr: 'src'}, 
            'home_team_logo',
            'home_team_name', 
            'home_team_shortname', 
            'time', 
            'watchability',
            // {name:'link', attr:'href'}
        ]
    };
    
    // var values = [];
    
    // for (let i = 0; i < games.length; i++)
    // values.push


    let lastDate = null; 
    let lastDateItem = null;


    for (game of games)
    {
        
        // let game = games[i];
        let gameDate = game.date;
        if (lastDate == null || gameDate.getTime() != lastDate.getTime())
        {
            lastDate = gameDate;
            // let weekDateHeader = document.createElement('h2');
            // weekDateHeader.className = 'week_date_header';
            // weekDateHeader.innerHTML = "Week " + game.week + " - " + game.date.toLocaleDateString('en-US', { weekday: 'long' });
            // gameListValues.push({week_date_header: weekDateHeader.outerHTML});

            let dateHeader = document.createElement('h2');
            dateHeader.className = 'week_date_header';
            dateHeader.innerHTML = game.date.toLocaleDateString('en-US', { weekday: "long", year: "numeric", month: "long", day: "numeric" }) + " - " + game.date.toLocaleTimeString('en-US', { timeStyle: 'short' });

            let dateItem = 
            {
                week_date_header: dateHeader.outerHTML,
                home_team_logo: "",
                anyWatchable: false,
                anyRanked: false
            }

            lastDateItem = dateItem;
            gameListValues.push(dateItem);
        }

        game.dateHeader = lastDateItem;
        if (lastDateItem != null) 
        {            
            if (!game.skip)
            {
                lastDateItem.anyWatchable = true; // assume this date has no watchable games
                // console.log("Setting watchable on dateHeader:"   , lastDateItem);
            }
            if (game.awayRank < 26 || game.homeRank < 26)
                lastDateItem.anyRanked = true; // assume this date has at least one watchable game
        }

        let dateString = new Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' }).format(game.date);
        // const gameElement = document.createElement('li');

        let gameString = 
            ((game.awayRank > 25) ? '' : game.awayRank.toString() + ' ') + game.awayTeam + " @ " + 
            ((game.homeRank > 25) ? '' : game.homeRank.toString() + ' ') + game.homeTeam;

        // game.awayTeam = "Air Force";
        let awayTeam = teamData.find((entry) => (entry.id == game.away_id));
        let homeTeam = teamData.find((entry) => (entry.id == game.home_id));

        let isHomeTBD = game.homeTeam.localeCompare("TBD") == 0;
        let isAwayTBD = game.awayTeam.localeCompare("TBD") == 0;

        let awayTeamImage = document.createElement('img');
        awayTeamImage.className = 'away_team_logo_img';

        if (isAwayTBD)
        {
            awayTeamImage.src = "https://a.espncdn.com/combiner/i?img=/i/teamlogos/default-team-logo-500.png";
            awayTeamImage.alt = "TBD logo";
            awayTeamImage.title = "TBD logo";
        }
        else
        {
            awayTeamImage.src = "https://a.espncdn.com/i/teamlogos/ncaa/500/" + game.away_id.toString() + ".png";
            awayTeamImage.alt = game.awayTeam + " logo";
            awayTeamImage.title = game.awayTeam + " logo";
        }

        let homeTeamImage = document.createElement('img');
        homeTeamImage.className = 'home_team_logo_img';

        if (isHomeTBD)
        {
            homeTeamImage.src = "https://a.espncdn.com/combiner/i?img=/i/teamlogos/default-team-logo-500.png";
            homeTeamImage.alt = "TBD logo";
            homeTeamImage.title = "TBD logo";
        }
        else
        {
            homeTeamImage.src = "https://a.espncdn.com/i/teamlogos/ncaa/500/" + game.home_id.toString() + ".png";
            homeTeamImage.alt = game.homeTeam + " logo";
            homeTeamImage.title = game.homeTeam + " logo";
        }

        let timeItem = document.createElement('a');
        timeItem.className = 'timelink';
        timeItem.href = `https://www.espn.com/college-football/game/_/gameId/${game.id}/`;
        timeItem.target = "_blank";
        timeItem.innerHTML = dateString;

        let item = {
            // week_date_header: "Week " + game.week + " - " + game.date.toLocaleDateString('en-US', { weekday: 'long' }),
            bowl_game_title: game.bowl_title,
            away_team_logo: awayTeamImage.outerHTML,
            away_team_name: ((game.awayRank > 25) ? '' : game.awayRank.toString() + ' ') + game.awayTeam + (awayTeam ? " " + awayTeam.mascot : ""),
            away_team_shortname: ((game.awayRank > 25) ? '' : game.awayRank.toString() + ' ') + game.awayTeam,
            at_sign: "@",
            home_team_logo: homeTeamImage.outerHTML, //("https://a.espncdn.com/i/teamlogos/ncaa/500/" + game.home_id.toString() + ".png"),
            home_team_name: ((game.homeRank > 25) ? '' : game.homeRank.toString() + ' ') + game.homeTeam + (homeTeam ? " " + homeTeam.mascot : ""),
            home_team_shortname: ((game.homeRank > 25) ? '' : game.homeRank.toString() + ' ') + game.homeTeam,
            // game: gameString,
            time: timeItem.outerHTML, //dateString,
            watchability: game.spread,
            gameitem: game,
            id: game.id,
            // link: `https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary?event=${game.id}`,
            // mascot: (awayTeam ? awayTeam.mascot : "") + ", " + (homeTeam ? homeTeam.mascot : ""),
        };

        // let _id = game.id;
        // delay(2000).then(() => {
            
        //     let item = gameDisplayList.get('id', _id);

        //     if (item == null)
        //     {
        //         console.warn("Item not found in gameDisplayList: " + game.id);
        //         return;
        //     }
            
        //     console.assert(item.length == 1);
        //     item = item[0];
        //     let watchability = item.elm.getElementsByClassName("watchability")[0];
        //     watchability.innerHTML = "updated value"; //game.watchability;
        //     // item.values()['watchability'] = "updated value"; //game.watchability;
        //     // watchability = item.values()['watchability'];
        //     // console.log("This message appears after 2 seconds.");
        //     // gameDisplayList.update();
        // });
        gameListValues.push(item);
        
    }


    if (gameDisplayList != null)
    {
        gameDisplayList.clear();
        gameDisplayList.add(gameListValues);
        gameDisplayList.search(''); //reset filer @TODO - persist/repapply filter?
    }
    else
    {
        gameDisplayList = new List('game-list-div', options);
        gameDisplayList.searchColumns = ['bowl_game_title', 'away_team_name', 'home_team_name', 'time' ];

        gameDisplayList.add(gameListValues);
    }
}

function viewFilterChanged()
{
    console.log(viewFilterControl.value);

    if (viewFilterControl.value == 'view_all_good_games')
    {
        gameDisplayList.search( 'xxx', () => {
            for (var k = 0, kl = gameDisplayList.items.length; k < kl; k++) {
                let item = gameDisplayList.items[k]
                item.found = false;
                let gameitem = item.values().gameitem;
                if (gameitem && !gameitem.skip)
                    item.found = true;
                else if (item.values().anyWatchable)
                {
                    console.log("Found watchable header:", item.values());
                    item.found = true;
                }
                // Insert your custom search logic here, set found = true
        
            }});
    }
    else if (viewFilterControl.value == 'view_ranked_games')
    {
        gameDisplayList.search( 'xxx', () => {
            for (var k = 0, kl = gameDisplayList.items.length; k < kl; k++) {
                let item = gameDisplayList.items[k]
                item.found = false;
                let gameitem = item.values().gameitem;
                if (gameitem && (gameitem.awayRank <= 25 || gameitem.homeRank <= 25) || item.values().anyRanked)
                    item.found = true;
                // Insert your custom search logic here, set found = true
        
            }});
    }
    else if (viewFilterChanged.value == 'view_todays_games')
    {
        // gameDisplayList.search( 'xxx', () => {
        //     for (var k = 0, kl = gameDisplayList.items.length; k < kl; k++) {
        //         let item = gameDisplayList.items[k]
        //         item.found = false;
        //         let gameitem = item.values().gameitem;
        //         if (gameitem.awayRank <= 25 || gameitem.homeRank <= 25)
        //             item.found = true;
        //         // Insert your custom search logic here, set found = true
        
        //     }});
    }
    else
    {
        gameDisplayList.search('');
    }

}

// export function handleWatchabilityClick(event) {
//     const watchabilityElement = event.currentTarget;
//     const listItem = watchabilityElement.closest('li');
    
//     // .data('gameitem');
//     console.log("Watchability clicked for game:", listItem);
// }
// window.handleWatchabilityClick = handleWatchabilityClick;